// extracted by mini-css-extract-plugin
module.exports = {"withoutArrow":"DspxPopover_withoutArrow__3q_TN"};